import { Grid } from '@packages/shared';
import { browserCanShare } from '../../../helpers/browserCanShare';
import type { ShareButtonProps } from '../../ShareButton';
import { ShareButton } from '../../ShareButton';

export const ShareButtonGridItemCore = (props: ShareButtonProps) => {
  if (!browserCanShare()) {
    return null;
  }

  return (
    /**
     * INFO: The grid is not included in ProductVariation.
     * This decision stems from the scenario where the button cannot be rendered due to the absence of window.navigator.share.
     * In this case, rendering an empty grid would result in unnecessary padding, which is to be avoided.
     */
    <Grid item xs={12}>
      <ShareButton {...props} />
    </Grid>
  );
};
